"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.initXcI18next = exports.getResources = exports.LanguageContainerHoc = exports.LanguageContainer = void 0;
var react_1 = __importStar(require("react"));
var i18next_1 = __importDefault(require("i18next"));
var hoist_non_react_statics_1 = __importDefault(require("hoist-non-react-statics"));
var react_i18next_1 = require("react-i18next");
var config_1 = require("./config");
require("./i18next");
var LanguageContainer = function (_a) {
    var useLanguage = _a.useLanguage, resources = _a.resources, defaultNS = _a.defaultNS, initOptions = _a.initOptions, children = _a.children;
    var _b = __read((useLanguage || config_1.config.useLanguage)(), 2), lng = _b[0], setLng = _b[1];
    var i18n = (0, react_1.useMemo)(function () {
        var I18n = i18next_1["default"].createInstance().use(react_i18next_1.initReactI18next);
        I18n.init(__assign(__assign(__assign({}, config_1.config.initOptions), initOptions), { lng: lng, defaultNS: defaultNS, resources: resources }));
        I18n.xcChangeLanguage = setLng;
        return I18n;
    }, [lng]);
    return react_1["default"].createElement(react_i18next_1.I18nextProvider, { i18n: i18n }, children(i18n));
};
exports.LanguageContainer = LanguageContainer;
var LanguageContainerHoc = function (data) { return function (WrapComponent) {
    var C = function (props) {
        return (react_1["default"].createElement(exports.LanguageContainer, __assign({}, data), function (i18n) { return react_1["default"].createElement(WrapComponent, __assign({}, props, { i18n: i18n })); }));
    };
    return (0, hoist_non_react_statics_1["default"])(C, WrapComponent);
}; };
exports.LanguageContainerHoc = LanguageContainerHoc;
function getResources(data) {
    var ret = {};
    Object.keys(data.langs).forEach(function (v) {
        if (!ret[v]) {
            ret[v] = {};
        }
        ret[v][data.defaultNS] = data.langs[v];
    });
    return ret;
}
exports.getResources = getResources;
function initXcI18next(data) {
    var useXcTranslation = function (options) {
        var ret = (0, react_i18next_1.useTranslation)(data.defaultNS, options);
        var getImg = function (getImgs) {
            var src = getImgs.keys().find(function (v) {
                return v.indexOf(ret.i18n.language) !== -1;
            });
            if (!src) {
                src = getImgs.keys().find(function (v) {
                    return v.indexOf(ret.i18n.options.fallbackLng[0]) !== -1;
                });
            }
            return src && getImgs(src);
        };
        ret.push(getImg);
        ret.getImg = getImg;
        return ret;
    };
    var XcLanguageContainerHoc = function (props) {
        var _a = props || {}, useLanguage = _a.useLanguage, _b = _a.initOptions, initOptions = _b === void 0 ? data.initOptions : _b;
        return (0, exports.LanguageContainerHoc)({
            useLanguage: useLanguage,
            defaultNS: data.defaultNS,
            resources: data.resources,
            initOptions: initOptions
        });
    };
    var XcTranslation = function (props) { return react_1["default"].createElement(react_i18next_1.Translation, __assign({}, props, { ns: data.defaultNS })); };
    var XcTrans = function (props) { return react_1["default"].createElement(react_i18next_1.Trans, __assign({}, props, { ns: data.defaultNS })); };
    return {
        useXcTranslation: useXcTranslation,
        XcTranslation: XcTranslation,
        XcLanguageContainerHoc: XcLanguageContainerHoc,
        XcTrans: XcTrans
    };
}
exports.initXcI18next = initXcI18next;
exports["default"] = {
    LanguageContainerHoc: exports.LanguageContainerHoc,
    LanguageContainer: exports.LanguageContainer,
    config: config_1.config,
    getResources: getResources,
    initXcI18next: initXcI18next
};
